// extracted by mini-css-extract-plugin
export default {"ourWebinarsContentDesktop":"OurWebinars_ourWebinarsContentDesktop__pvM0e"};